import OBJ0 from "../assets/drum/shape0_0.obj";
import OBJ1 from "../assets/drum/shape0_1.obj";
import OBJ2 from "../assets/drum/shape0_2.obj";
import OBJ3 from "../assets/drum/shape0_3.obj";
import OBJ4 from "../assets/drum/shape0_4.obj";
import OBJ5 from "../assets/drum/shape0_5.obj";
import OBJ6 from "../assets/drum/shape0_6.obj";
import OBJ7 from "../assets/drum/shape0_7.obj";

import OBJ8 from "../assets/drum/shape1_0.obj";
import OBJ9 from "../assets/drum/shape1_1.obj";
import OBJ10 from "../assets/drum/shape1_2.obj";
import OBJ11 from "../assets/drum/shape1_3.obj";
import OBJ12 from "../assets/drum/shape1_4.obj";
import OBJ13 from "../assets/drum/shape1_5.obj";
import OBJ14 from "../assets/drum/shape1_6.obj";
import OBJ15 from "../assets/drum/shape1_7.obj";

import OBJ16 from "../assets/drum/shape2_0.obj";
import OBJ17 from "../assets/drum/shape2_1.obj";
import OBJ18 from "../assets/drum/shape2_2.obj";
import OBJ19 from "../assets/drum/shape2_3.obj";
import OBJ20 from "../assets/drum/shape2_4.obj";
import OBJ21 from "../assets/drum/shape2_5.obj";
import OBJ22 from "../assets/drum/shape2_6.obj";
import OBJ23 from "../assets/drum/shape2_7.obj";

import PNG0 from "../assets/drum/shape0.pngfeat0.png";
import PNG1 from "../assets/drum/shape0.pngfeat1.png";
import PNG2 from "../assets/drum/shape1.pngfeat0.png";
import PNG3 from "../assets/drum/shape1.pngfeat1.png";
import PNG4 from "../assets/drum/shape2.pngfeat0.png";
import PNG5 from "../assets/drum/shape2.pngfeat1.png";

import JSON from "../assets/drum/mlp.json";

const DRUM = [
  OBJ0,
  OBJ1,
  OBJ2,
  OBJ3,
  OBJ4,
  OBJ5,
  OBJ6,
  OBJ7,
  OBJ8,
  OBJ9,
  OBJ10,
  OBJ11,
  OBJ12,
  OBJ13,
  OBJ14,
  OBJ15,
  OBJ16,
  OBJ17,
  OBJ18,
  OBJ19,
  OBJ20,
  OBJ21,
  OBJ22,
  OBJ23,
  PNG0,
  PNG1,
  PNG2,
  PNG3,
  PNG4,
  PNG5,
  JSON,
];

export default DRUM;
